import Container from "react-bootstrap/esm/Container";
import iaq_logo from "../images/IAQ-logo.PNG";

export default function Home() {
  return (
    <Container>
      <h1 id="config_header">Tokenomics</h1>
      <div className="bottom-line"></div>
      <div className="text-center">
        <i id="reward_logo" className="bi bi-trophy-fill h3"></i>
        <p id="reward_lead">Indoor Air Quality token, IAQ</p>
        <a id="reward_chart" href="https://vestige.fi/asset/923640017" target="_blank">Chart</a>
      </div>
      <br/>
      <div className="text-center">
        <img src={iaq_logo} alt="IAQ_logo"/>
      </div>
      <br/>
      <p id="reward_lead">Powered by the Algorand blockchain</p>
      <div className="bottom-line"></div>
      <p className="config_lead">The Indoor Air Quality (IAQ) token is the native token of the Indoor Air Quality project.</p>
      <p className="config_lead">The total supply of IAQ tokens is 1,000,000,000</p>
      <p className="config_lead">200,000,000 tokens from the creator account have been moved to the reserve account , wallet address elementdata.algo (2RCTDVFTMYFDMGAVPNNGMOB24Z6SOCYD5HCYYCALVSWO34CNOEFEM5WWZ4) ,
        which will be used for providing liquidity, burning IAQ token and distributing rewards.</p>
      <p className="config_lead">The purpose of the IAQ token is to reward users who own an air quality monitor device and contribute data to the project.</p>
      <p className="config_lead">The data collected is available for free on the project's website, allowing users to monitor the air quality in their area.</p>
      <p className="config_lead">There are four plans available for users to choose from.</p>
      <p className="config_lead">The default plan is free for all users and provides a reward of 0.01 IAQ tokens for each hour of data sent.</p>
      <p className="config_lead">Maximum balance for this plan is capped at 3 IAQ tokens.</p>
      <p className="config_lead">It serves as a trial/demo mode, for users to setup the app properly, this plan is excluded from the payout.</p>
      <p className="config_lead">The second plan (Bond) offers a reward of 0.10 IAQ tokens per hour and it costs 25 USDC.</p>
      <p className="config_lead">Everyday, all the proceeds from the Bond plan will be swapped to ALGO in order to fill in the Liquidity Pool, which will act as a buy-back and an equal amount of IAQ from the reserve will be burned.</p>      
      <p className="config_lead">In short: 1 Bond plan purchased = $25 worth of ALGO + $25 worth of IAQ are burned.</p>
      <p className="config_lead">As always, in order to stay transparent, here is the wallet address for the Bond plans: FPG7PECKJ3I7XTLRHFIW5EW7WMAELH7NN5AC2PG4KY7WJDDJP5I5RUELAA</p>
      <p className="config_lead">Wallet address for the burned IAQ tokens: BURNGPZ2Z2OFKIMBBGNGX5G5ASHPG3NWLYUREMGML5R5DYR5K5GK6P6NEM</p>      
      <p className="config_lead">The third plan (Starter) offers a reward of 0.20 IAQ tokens per hour and requires a service fee of $50. </p>
      <p className="config_lead">The fourth plan (Premium) offers a reward of 0.35 IAQ tokens per hour and requires the user to provide liquidity for the token on an exchange.</p>
      <p className="config_lead">The reserve account will be used for providing liquidity and distributing rewards to users who participate in the project.</p>
      <p className="config_lead">All rewards generated by the IAQ token are distributed to users who contribute data to the project.</p>
      <p className="config_lead">The IAQ token does not provide any rewards or revenue for the team behind the project.</p>
      <p className="config_lead">The service fee (Starter plan) is the primary source of revenue for the project.</p>
      {/* <p className="config_lead">There are no burning or locking mechanisms in place for the IAQ token.</p> */}
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
    </Container>
  )
}
